export const LANGUAGES = [
  {
    code: 'en',
    label: 'English'
  },
  {
    code: 'pl',
    label: 'Polish'
  }
]
